<template>
  <ul class="breadcrumb">
    <li v-for="(option, index) in options" :key="index">
      <router-link v-if="option.to" :to="option.to">{{option.title}}</router-link>
      <i v-if="option.to" class="icon-triangle-right"></i>
      <span v-else>{{option.title}}</span>
    </li>
  </ul>
</template>

<script>
import Container from '@/components/layout/Container.vue';

export default {
  name: 'Breadcrumb',
  components: {
    'v-container': Container,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
$component: '.breadcrumb';
#{$component} {
  --theme-color: #{$color-a};
  display: flex;
  flex-wrap: wrap;
  margin-bottom: $section-gutter / 2;
  li {
    margin-right: $gutter;
    font-size: $font-size-l;
  }
  .icon-triangle-right {
    display: inline-block;
    margin-left: $gutter;
    font-size: $font-size-xs;
    color: var(--theme-color);
  }
  a {
    text-decoration: none;
    color: $color-sys-e;
    font-weight: $font-weight-heavy;
    transition: color $transition-duration $transition-timing-function;
    &:hover {
      color: var(--theme-color);
    }
  }
  span {
    color: $color-sys-e;
    word-wrap: no-wrap;
  }
}
</style>
